import { compact } from 'lodash'
import { useMemo } from 'react'

import {
  useGetCost,
  useGetCostTransactionById,
  useGetCostTransactionsHistoryInfinite,
} from './queries'

export const useCost = () => {
  const { data, ...rest } = useGetCost()
  return useMemo(
    () => ({
      ...rest,
      data: data && {
        ...data,
      },
    }),
    [data, rest]
  )
}
export const useCostTransactionHistory = () => {
  const { data, ...rest } = useGetCostTransactionsHistoryInfinite()

  const { costs, totalCost } = useMemo(() => {
    const pages = data?.pages ?? []

    return {
      costs: compact(pages.flatMap((page) => page.costs?.costs ?? [])),
      totalCost: pages[0]?.costs?.totalCost ?? 0,
    }
  }, [data])

  return {
    ...rest,
    data: costs,
    totalCost,
  }
}

export const useFindTransactionById = (id: string) => {
  const { data } = useGetCostTransactionById(id)

  return useMemo(() => ({ ...data }), [data])
}
